@if (loader.getLoading()) {
<div class="active">
  <mat-spinner color="accent" class="position"></mat-spinner>
</div>
}